





























































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import StatusBind from '@/components/common/StatusBind.vue'
import ImportExcelDialog from '@/components/common/ImportExcelDialog.vue'
import SearchDialog from './SearchDialog.vue'
import $Api from '@api'
import { finalize } from 'rxjs/operators'
import { DateTime } from '@/utils/filters'
import { bindMap } from '@/utils/status-map'

@Component({
    components: {
        SearchForm,
        TableForm,
        ImportExcelDialog,
        StatusBind,
        SearchDialog
    }
})
export default class BankCard extends Vue {
    dateTime = DateTime
    bindOptions = bindMap.createArray()
    operatorsOptions = []
    searchForm: any = {
        current: 1,
        size: 10,
        effectiveDateBegin: null,
        effectiveDateEnd: null,
        createTimeBegin: null,
        createTimeEnd: null,
        bindTimeBegin: null,
        bindTimeEnd: null,
        status: null,
        createBy: null
    }

    effectiveDate = null
    createTime = null
    bindTime = null

    tableLoading = false
    tableData = []
    total = 0
    currentRow = null
    totalAmount = 0

    showImportDialog = false
    importLoading = false

    showSearchDialog = false
    searchLoading = false

    onSearchSubmit() {
        this.searchForm.current = 1
        this.getData()
        this.getAllAmount()
    }

    getData(pageQuery = {}) {
        this.tableLoading = true
        $Api.receiptService
            .getBankSlipsList(Object.assign(this.searchForm, pageQuery))
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(data => {
                this.tableData = data.records
                this.total = data.total
            })
    }

    getOperators() {
        $Api.receiptService.getOperators()
            .subscribe(data => {
                // console.log(res)
                if (data && data.length > 0) {
                    this.operatorsOptions = data.map((item: string) => ({ label: item, value: item }))
                }
            })
    }

    async view(row: any) {
        this.showSearchDialog = true
        this.currentRow = { ...row }
    }

    // 下载模板
    download() {
        $Api.receiptService.download().subscribe(data => {
            const url = window.URL.createObjectURL(new Blob([data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'template.xlsx')
            document.body.appendChild(link)
            link.click()
        })
    }

    // 导入
    upload() {
        this.showImportDialog = true
    }

    onImportDialogClose() {
        this.showImportDialog = false
    }

    startUpload(file) {
        const data = new FormData()
        data.append('file', file.raw)

        this.importLoading = true

        $Api.receiptService.uploadBankSlipsFile(data)
            .pipe(finalize(() => {
                this.importLoading = false
            }))
            .subscribe(res => {
                this.onImportDialogClose()
                this.onSearchSubmit()
                this.$alert(res, this.$t('documents.import.result') as string, {
                    dangerouslyUseHTMLString: true
                })
            }, error => {
                this.$message.error(error.message)
            })
    }

    getAllAmount() {
        $Api.receiptService.getAllAmount({ ...this.searchForm })
            .subscribe(res => {
                this.totalAmount = res
            })
    }

    onSearchDialogClose() {
        this.showSearchDialog = false
    }

    created() {
        this.getData()
        this.getOperators()
        this.getAllAmount()
    }

    get country() {
        return (this.$store.state.auth.authInfo || {}).country
    }

    onFormReset() {
        this.effectiveDate = null
        this.createTime = null
        this.bindTime = null
    }

    @Watch('effectiveDate')
    onEffectiveDatenChange(date: [Date, Date]): void {
        if (!date) {
            this.searchForm.effectiveDateBegin = null
            this.searchForm.effectiveDateEnd = null
        } else {
            const [startTime, endTime] = date
            this.searchForm.effectiveDateBegin = startTime.getTime()
            this.searchForm.effectiveDateEnd = endTime.getTime()
        }
    }

    @Watch('createTime')
    onCreateTimeChange(date: [Date, Date]): void {
        if (!date) {
            this.searchForm.createTimeBegin = null
            this.searchForm.createTimeEnd = null
        } else {
            const [startTime, endTime] = date
            this.searchForm.createTimeBegin = startTime.getTime()
            this.searchForm.createTimeEnd = endTime.getTime()
        }
    }

    @Watch('bindTime')
    onBindTimeChange(date: [Date, Date]): void {
        if (!date) {
            this.searchForm.bindTimeBegin = null
            this.searchForm.bindTimeEnd = null
        } else {
            const [startTime, endTime] = date
            this.searchForm.bindTimeBegin = startTime.getTime()
            this.searchForm.bindTimeEnd = endTime.getTime()
        }
    }
}
